const textEncoder = new TextEncoder();

/** UTF-8 byte length - `string.length` counts UTF-16 units and undercounts. */
const byteLength = (text: string): number => textEncoder.encode(text).length;

/**
 * Best-effort size of an already-parsed response body, used when the
 * `Content-Length` header isn't readable. Returns undefined when unknown.
 * Serialising can be costly, so callers should only use it for slow requests.
 */
export function estimateBodySize(body: unknown): number | undefined {
  if (body === null || body === undefined) {
    return undefined;
  }

  if (typeof body === 'string') {
    return byteLength(body);
  }

  if (body instanceof Blob) {
    return body.size;
  }

  if (body instanceof ArrayBuffer) {
    return body.byteLength;
  }

  try {
    const json = JSON.stringify(body);
    return json === undefined ? undefined : byteLength(json);
  } catch {
    // Circular or otherwise non-serialisable body - treat the size as unknown.
    return undefined;
  }
}
